//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "LineWidthChoice",

  props: {
    lineWidth: {
      type: Number,
      default: 2
    },
    iconTooltip: {
      type: String,
      default: 'Толщина границы'
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      marks: {
        1: '1',
        2: '2',
        3: '3',
        4: '4'
      }
    }
  },

  methods: {
    onChange(evt) {
      this.$emit('update:line-width', evt)
    }
  },
}
